// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3KmJx","footer":"ModalInfo_footer__3rweS"};